import { render, staticRenderFns } from "./uxBase.vue?vue&type=template&id=5471389e&scoped=true"
import script from "./uxBase.vue?vue&type=script&lang=js"
export * from "./uxBase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5471389e",
  null
  
)

export default component.exports